export function afterEventDrop(event, saveEventOnDb) {
    if (!event.eventRecords || !event.eventRecords[0]) return;
    return saveEventOnDb(event, event.source);
}